import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router";
import {
    useGetEmployeeByIdQuery,
    useGetEmployeeMeQuery,
} from "../../../common/api/employee";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
    setDeactivatedEmployee,
    setIsDeactivateEmployeeConfirmationModalOpen,
} from "../../../modals/DeactivateEmployeeConfirmationModal/DeactivateEmployeeConfirmationModalSlice";

type UseEmployeeDetailStatusButtonsResult = {
    isVisible: boolean;
    isLoading: boolean;
    onDeactivateClick: () => void;
};

export const useEmployeeDetailStatusButtons =
    (): UseEmployeeDetailStatusButtonsResult => {
        const employeeId = Number(useParams().employeeId);
        const dispatch = useAppDispatch();
        const [statusFetching] = useState(false);

        const { isPatchDeactivateEmployeeSuccess } = useAppSelector(
            (state) => state.deactivateEmployeeConfirmationModal,
        );

        const { data: employeeData, refetch: refetchEmployee } =
            useGetEmployeeByIdQuery({ id: employeeId });

        const { data: employeeMeData } = useGetEmployeeMeQuery({});

        useEffect(() => {
            if (isPatchDeactivateEmployeeSuccess) {
                refetchEmployee();
            }
        }, [isPatchDeactivateEmployeeSuccess, refetchEmployee]);

        const isVisible = useMemo(() => {
            if (!employeeData) return false;
            if (employeeData.id === employeeMeData?.id) return false;
            return true;
        }, [employeeData, employeeMeData]);

        const onDeactivateClick = useCallback(() => {
            if (!employeeData) return;
            dispatch(setIsDeactivateEmployeeConfirmationModalOpen(true));
            dispatch(setDeactivatedEmployee(employeeData));
        }, [dispatch, employeeData]);

        return {
            isVisible,
            isLoading: statusFetching,
            onDeactivateClick,
        };
    };
